import React from 'react';

export const paymentByDateTableConfig = () => ({
   columns: [
      { title: 'From Date', field: 'fromDate', filterAndSearch: false },
      { title: 'To Date', field: 'toDate', filterAndSearch: false },
      {
         title: 'Total Orders', field: 'totalOrders', filterAndSearch: false,
         render: rowData => <div>{rowData.totalOrders || "0"}</div>
      },
      {
         title: 'Total Revenue', field: 'total_revenue', filterAndSearch: false,
         render: rowData => <div><b>&#8377;{rowData.total_revenue.toFixed(2) || "0"}</b></div>
      },
   ],
})

export const paymentTableConfig = () => ({
   columns: [
      { title: 'Date', field: 'date', filterAndSearch: true },
      { title: 'Total Orders', field: 'total_order', filterAndSearch: true },
      {
         title: 'Total Revenue', field: 'total_revenue', filterAndSearch: true,
         render: rowData => <div>&#8377;{rowData.total_revenue.toFixed(2) || "0"}</div>
      },
   ],
})
